import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import cx from "classnames";

const TextareaS1 = ({
	className = "",
	label = "",
	readOnly = false,
	textareaClasses = "",
	placeholder = "",
	type = "text",
	size = "default",
	field,
	form: { touched, errors },
	...props
}) => {
	const { t } = useTranslation("main");
	const classes = cx(
		'form-field',
		touched[field.name] && errors[field.name] && 'form-field--error',
		field.value && 'form-field--active',
		`form-field--${size}`,
		className
	);

	return (
		<div className={classes}>
			{label && (
				<label className="form-field__label">{label}</label>
			)}
			<textarea
				className={`form-field__textarea ${textareaClasses}`}
				readOnly={readOnly}
				{...{ placeholder, type }}
				{...field}
				{...props}
			/>
			{touched[field.name] && errors[field.name] && (
				<div className="form-field__error">{t(errors[field.name])}</div>
			)}
		</div>
	);
};

TextareaS1.propTypes = {
	label: PropTypes.string,
	type: PropTypes.oneOf(["text", "password"]),
	className: PropTypes.string,
	textareaClasses: PropTypes.string,
	placeholder: PropTypes.string,
	readOnly: PropTypes.bool,
	size: PropTypes.oneOf(["default", "large", "small"]),
};

export default TextareaS1;
